import { useCallback, useEffect, useRef } from "react";

import { getCancelTokenSource } from "@/browser";

export function useCancelTokenSource() {
  const source = useRef(getCancelTokenSource());
  const cleanup = useCallback(() => {
    source.current?.cancel();
  }, [source]);
  const refresh = () => {
    cleanup();
    source.current = getCancelTokenSource();
  };

  useEffect(() => {
    return cleanup;
  }, [cleanup]);

  return { refreshToken: refresh, source };
}
